"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BadgeTextSizes = exports.BadgeTextColors = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      "& .MuiBadge-badge": {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        whiteSpace: "nowrap",
        position: "static",
        transform: "none"
      }
    },
    white: {
      "& .MuiBadge-badge": {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.common.white
      }
    },
    critical: {
      "& .MuiBadge-badge": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.error.main
      }
    },
    positive: {
      "& .MuiBadge-badge": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.success.main
      }
    },
    neutral: {
      "& .MuiBadge-badge": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.warning.main
      }
    },
    premium: {
      "& .MuiBadge-badge": {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.warning.light
      }
    },
    grey: {
      "& .MuiBadge-badge": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[600]
      }
    },
    turquoise: {
      "& .MuiBadge-badge": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.main
      }
    },
    small: {
      "& .MuiBadge-badge": {
        height: 20,
        fontSize: theme.typography.caption.fontSize,
        lineHeight: "20px",
        borderRadius: 10
      }
    },
    standard: {
      "& .MuiBadge-badge": {
        height: 24,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: "24px",
        borderRadius: 12
      }
    },
    bold: {
      "& .MuiBadge-badge": {
        fontWeight: 700
      }
    }
  };
});
/**
 * **Badge is a decorative indicator used to either call attention to a related item or which hold small amounts of information.**
 *
 * There are  7 colours: white, positive, neutral, critical, premium, grey, turquoise
 */

var BadgeText = function BadgeText(_ref) {
  var _classNames;

  var text = _ref.text,
      color = _ref.color;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Badge, {
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles[color], true), _defineProperty(_classNames, styles.standard, true), _classNames)),
    badgeContent: text
  });
};

BadgeText.propTypes = {
  /** The text to display inside the badge. This component is used as indicator or label */
  text: _propTypes.default.string.isRequired,

  /** The available colors of the badge */
  color: _propTypes.default.oneOf(["white", "positive", "neutral", "critical", "premium", "grey", "turquoise"])
};
BadgeText.defaultProps = {
  color: "error"
};
var BadgeTextColors = ["white", "positive", "neutral", "critical", "premium", "grey", "turquoise"];
exports.BadgeTextColors = BadgeTextColors;
var BadgeTextSizes = ["standard", "small"];
exports.BadgeTextSizes = BadgeTextSizes;
var _default = BadgeText;
exports.default = _default;